import { render, staticRenderFns } from "./PreviewCard.vue?vue&type=template&id=6706bbc4&scoped=true&"
import script from "./PreviewCard.vue?vue&type=script&lang=js&"
export * from "./PreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCard.vue?vue&type=style&index=0&id=6706bbc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6706bbc4",
  null
  
)

export default component.exports